import React, { useEffect, useState } from 'react';

import Sidebar from '../layouts/Sidebar';
import Spinner from '../components/ui/Spinner';
import AuditService from '../services/AuditService';
import { governanceControls } from '../mock/commandCenterData';

export default function Governance() {
  const [auditRows, setAuditRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await AuditService.findAll({ page: 1, pageSize: 8 });
        setAuditRows(data.rows || []);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    load();
    const intervalId = setInterval(load, 30000);
    return () => clearInterval(intervalId);
  }, []);

  let auditTimelineContent;
  if (loading) {
    auditTimelineContent = (
      <div className="flex items-center justify-center gap-2 text-sm text-neutral-400 dark:text-neutral-500 py-6">
        <Spinner size="sm" />
        <span>Loading audit timeline…</span>
      </div>
    );
  } else if (auditRows.length > 0) {
    auditTimelineContent = auditRows.map((row) => (
      <div key={row.id} className="timeline-row">
        <time>{new Date(row.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</time>
        <div>
          <b className="text-sm text-neutral-800 dark:text-neutral-100">{row.memberEmail || 'System'}</b>
          <p className="text-xs text-neutral-500 dark:text-neutral-500 mt-1">
            {row.action} &bull; {row.category}
            {row.path ? ` — ${row.method} ${row.path}` : ''}
          </p>
        </div>
      </div>
    ));
  } else {
    auditTimelineContent = <div className="text-sm text-neutral-400 dark:text-neutral-500 text-center py-6">No audit activity yet</div>;
  }

  return (
    <Sidebar title="Governance">
      <section className="space-y-6">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl border border-neutral-200 shadow-subtle p-6 dark:bg-ink-900 dark:border-neutral-700">
            <h3 className="font-bold text-neutral-800 mb-4 dark:text-neutral-100">Governance Controls</h3>
            <div className="space-y-3">
              {governanceControls.map(([level, text]) => (
                <div key={text} className={`alert-row ${level}`}>
                  {text}
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white rounded-xl border border-neutral-200 shadow-subtle p-6 dark:bg-ink-900 dark:border-neutral-700">
            <h3 className="font-bold text-neutral-800 mb-4 dark:text-neutral-100">Audit Timeline</h3>
            <div className="space-y-3">
              {auditTimelineContent}
            </div>
          </div>
        </div>
      </section>
    </Sidebar>
  );
}
